// extracted by mini-css-extract-plugin
export default {"SearchResults":"SearchResults_SearchResults__y7+Qh","SearchNote":"SearchResults_SearchNote__NNhZ+"};